import { FC, ReactNode } from 'react';
import NewTooltip from './NewTooltip';

import { LuBadgeDollarSign } from "react-icons/lu";
import { FaRegUser } from "react-icons/fa";

import { TbLetterA, TbLetterV, TbSignature } from "react-icons/tb";
import { ImManWoman } from "react-icons/im";
import { FaUserTie } from "react-icons/fa6";

interface IconRegistrationProfileProps {
  profile: string;
}

const IconRegistrationProfile: FC<IconRegistrationProfileProps> = ({ profile }) => {

  const icons: { [key: string]: ReactNode } = {
    "ISSUER": <FaRegUser className='text-xl' />,
    "RECIPIENT": <LuBadgeDollarSign className='text-xl' />,
    "GUARANTOR-RETAIL": <TbLetterV className='text-xl' />,
    "GUARANTOR-WHOLESALE": <TbLetterA className='text-xl' />,
    "SIGNATORY": <TbSignature className='text-xl' />,
    "GUARANTOR": <TbLetterA className='text-xl' />,
    "CONSENTING_PARTY": <ImManWoman className='text-xl' />,
    "FINANCIAL_REPRESENTATIVE": <FaUserTie className='text-xl' />,
  };

  const tooltips: { [key: string]: string } = {
    "ISSUER": "Emitente",
    "RECIPIENT": "Beneficiário",
    "GUARANTOR-RETAIL": "Avalista Varejo",
    "GUARANTOR-WHOLESALE": "Avalista Atacado",
    "SIGNATORY": "Signatário",
    "GUARANTOR": "Avalista",
    "CONSENTING_PARTY": "Anuente",
    "FINANCIAL_REPRESENTATIVE": "Representante Financeiro",
  };

  return (
    <NewTooltip content={tooltips[profile]}>
      {icons[profile]}
    </NewTooltip>
  );
};

export default IconRegistrationProfile;